'use client'

import { Box, Paper, IconButton, Stack, useMediaQuery } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { usePathname, useRouter } from "next/navigation";
import dynamic from "next/dynamic";
import { useTranslations } from "next-intl";
const Image = dynamic(() => import('@/components/common/image'), { ssr: false });

type NavItem = {
    label: string;
    value: string;
    icon: string;
    active_icon: string;
};

const navItems: NavItem[] = [
    { label: "Homepage", value: "/home", icon: '/navbar/Home (1).svg', active_icon: '/navbar/Home.svg' },
    { label: "Programs", value: "/programs/list/programs", icon: '/navbar/Library (1).svg', active_icon: '/navbar/Library.svg' },
    { label: "Journeys", value: "/journeys", icon: '/navbar/Document One Page (1).svg', active_icon: '/navbar/Document One Page.svg' },
    { label: "Dana", value: "/dana", icon: '/icons/dana.svg', active_icon: '/navbar/dana icon 1.svg' },
];

export default function MobileNav() {
    const router = useRouter();
    const pathname = usePathname();
    const is_mobile = useMediaQuery('(max-width:1024px)');
    const t = useTranslations('header.links');

    const handleClick = (value: string) => {
        router.push(`${value}`);
    };

    return (
        <Paper
            className={'__MobileNav__1__'}
            sx={{
                position: "fixed",
                bottom: 32,
                left: 12,
                right: 12,
                zIndex: 1000,
                borderRadius: 100,
                boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.20)',
                padding: '10px',
                display: is_mobile ? "block" : "none"
            }}
            elevation={3}
        >
            <Stack
                className={'__MobileNav__2__'}
                useFlexGap
                direction={'row'}
                justifyContent={'space-between'}
            >
                {navItems.map((item) => {
                    const isActive = pathname?.startsWith(item.value);
                    return (
                        <Box
                            className={'__MobileNav__3__'}
                            key={item.value}
                            onClick={() => handleClick(item.value)}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: '5px',
                                px: isActive ? '15px' : 0,
                                py: '10px',
                                borderRadius: "100px",
                                bgcolor: isActive ? "#7B61FF" : "transparent",
                                color: isActive ? "#fff" : "#444",
                                cursor: "pointer",
                                transition: "all 0.3s ease",
                                overflow: "hidden",
                            }}
                        >
                            <IconButton
                                className={'__MobileNav__4__'}
                                sx={{ color: "inherit" }}
                                disableRipple
                                disableFocusRipple
                            >
                                <Image
                                    alt="taking note"
                                    url={isActive ? item.icon : item.active_icon}
                                    className="w-6"
                                />
                            </IconButton>
                            <AnimatePresence
                                className={'__MobileNav__4__'}
                            >
                                {/* {isActive && ( */}
                                <motion.div
                                    initial={{ opacity: 0, width: 0 }}
                                    animate={{ opacity: 1, width: isActive ? 'fit-content' : 0 }}
                                    exit={{ opacity: 0, width: 0 }}
                                    transition={{ duration: 0.2 }}
                                    style={{ whiteSpace: "nowrap", fontWeight: 700, overflow: 'hidden', fontSize: 12 }}
                                >
                                    {t(item.label)}
                                </motion.div>
                                {/* )} */}
                            </AnimatePresence>
                        </Box>
                    );
                })}
            </Stack>
        </Paper>
    );
};
